<template>
    <section class="contact-opportunities">
        <div class="opportunities-header">
            <h3>Opportunities</h3>

            <ds-filled-button
                data-qa="add-opportunity"
                class="only-desktop"
                @click="addOpportunityLink"
            >
                Add opportunity
            </ds-filled-button>

            <ds-icon-button
                data-qa="add-opportunity"
                class="only-mobile add-icon"
                name="add-fill"
                @click="addOpportunityLink"
            />
        </div>

        <div v-if="isOpportunities">
            <ds-list-item
                v-for="(opportunity , index) in opportunities"
                :key="opportunity.id"
                data-qa="opportunities-list"
                class="opportunity-list-item"
                :border-style="index === opportunities.length - 1 ? 'none' : 'partial'"
                @click="editOpportunityLink(opportunity.id)"
            >
                <template #leading>
                    <ds-icon class="only-desktop folder-icon" name="folder" />
                </template>

                <template #description>
                    <h6 class="semibold">
                        {{ opportunity.title }}
                    </h6>

                    <div>
                        Rep: {{ opportunity.rep }}
                    </div>

                    <div>
                        Next action: {{ opportunity.nextActionDate }} - {{ opportunity.nextActionNotes }}
                    </div>

                    <div class="label only-mobile">
                        {{ opportunity.stage }}
                    </div>
                </template>

                <template #trailing>
                    <div class="opportunities-updated">
                        <div class="last-updated">
                            Last updated
                        </div>

                        <div>
                            {{ opportunity.lastUpdated }}
                        </div>

                        <div class="label only-desktop">
                            {{ opportunity.stage }}
                        </div>
                    </div>
                </template>
            </ds-list-item>
        </div>

        <div v-else class="no-data">
            There is no opportunities on {{ contact.firstName }}
        </div>

        <ds-infinite-scroll
            v-if="isOpportunities"
            :limit="limit"
            :offset="offset"
            :loading="loading"
            :no-more-data="noMoreData"
            data-qa="opportunities-infinite-scroll"
            @load="handleInfiniteScrollLoad"
        >
            <ds-placeholder
                v-for="i in 3"
                :key="i"
                :rows="placeholder"
                class="placeholder"
            />
        </ds-infinite-scroll>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        contact: Object,
        tabName: String,
    },

    data() {
        return {
            url: '/app/opportunity',
            opportunities: [],
            offset: 0,
            limit: 25,
            loading: true,
            noMoreData: false,
            placeholder: [
                { height: '1rem', boxes: [0.3, 6, 6] },
            ],
        };
    },

    created() {
        this.loadOpportunities();
    },

    computed: {
        isOpportunities() {
            return Boolean(this.opportunities.length);
        },
    },

    methods: {
        async loadOpportunities() {
            try {
                const params = `offset=${this.offset}&limit=${this.limit}`;
                const onScrollOpportunities = await axios.get(`${this.url}/${this.contact.id}?${params}`);

                this.offset += onScrollOpportunities.data.length;
                this.opportunities.push(...onScrollOpportunities.data);

                if (onScrollOpportunities.data.length < this.limit) {
                    this.noMoreData = true;
                }
            } catch (error) {
                this.$error({ message: 'Unable to get opportunities for this contact' });
            }
        },

        async handleInfiniteScrollLoad() {
            this.loading = true;
            await this.loadOpportunities();

            this.loading = false;
        },

        addOpportunityLink() {
            window.open(`/Opportunity/manageOpportunity.jsp?view=add&Opportunity0ContactID=${this.contact.id}`);
        },

        editOpportunityLink(id) {
            window.open(`/Opportunity/manageOpportunity.jsp?view=edit&ID=${id}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-opportunities {
    .opportunities-header {
        display: flex;
        justify-content: space-between;
        padding: $spacing-200 0;
        border-bottom: solid px-to-rem(1px) $color-gray-200;
        align-items: center;
    }

    .label {
        margin-top: 0.8rem;
        padding: $spacing-100;
        min-height: 3rem;
        display: inline-flex;
        align-items: center;
        font-size: small;
        color: $color-text;
        background-color: $color-gray-200;
        border-radius: $border-radius * 1.5;
    }

    h6 {
        margin-bottom : 0.3rem;
        text-transform: none;
    }

    .no-data {
        font-size: 1.2rem;
        padding: $spacing-600 0 $spacing-200;
        text-align: center;
        color: $color-gray-darker;
    }

    .last-updated {
        margin-bottom: 0.2rem;
    }

    .opportunities-updated {
        text-align: right;
    }

    .placeholder {
        margin-bottom: $spacing-200;
    }

    .only-mobile {
        display: none;
    }

    .folder-icon {
        width: 3.5rem;
        padding-right: 0.6rem;
    }

    .list-item.opportunity-list-item {
        padding: 0;

        &:hover {
            background-color: $color-gray-100;
            cursor: pointer;
        }
    }

    @media($small) {
        .only-desktop {
            display: none;
        }

        .only-mobile {
            display: inline-block;
        }

        .add-icon {
            color: $color-blue;
        }

        h6 {
            padding-top: $spacing-100;
        }
    }
}
</style>
